"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROW_LIST_FIELD_TYPE = void 0;
exports.findRowListField = findRowListField;
/**
 * The workflow start field type "Zeilenliste" / "Row list": a workflow with
 * such a field runs once for all rows of a batch and receives them in it;
 * without one it runs per row. The name of the field means nothing.
 */
exports.ROW_LIST_FIELD_TYPE = 'row-list';
/** The first start field of type row list; the workflow then runs once for all rows. */
function findRowListField(fields) {
    return fields.find(field => field.type.toLowerCase() === exports.ROW_LIST_FIELD_TYPE);
}
